export default __webpack_public_path__ + "static/media/EY_logo.570845ef.png";